import fetchData from "../API/Fetch";
import { store } from "../store";

export default async function fetchEstablishments() {
  let result = await fetchData(`/establishments/`);
  store.dispatch({
    type: "establishments/update",
    payload: result ? result : [],
  });
  
  // Récupérer l'établissement actuellement sélectionné dans le store
  const currentSelected = store.getState().selectedEstablishment;
  
  // Récupérer l'établissement sauvegardé dans localStorage
  const savedEstablishment = localStorage.getItem("selectedEstablishment");
  
  // Si on a déjà une sélection valide dans le store (pas l'état initial), on la garde
  if (currentSelected !== "0" && currentSelected !== [] && currentSelected) {
    // Garder la sélection actuelle
    return;
  }
  
  // Sinon, utiliser la valeur sauvegardée si elle existe
  if (savedEstablishment !== null && savedEstablishment !== "undefined" && savedEstablishment !== "") {
    // Garder comme string si "0", sinon convertir en nombre
    let establishmentId;
    if (savedEstablishment === "0") {
      establishmentId = "0";
    } else {
      establishmentId = parseInt(savedEstablishment);
      // Vérifier que l'établissement existe toujours
      if (result && !result.find(e => e.id === establishmentId)) {
        establishmentId = "0"; // Retourner à "Tout" si l'établissement n'existe plus
      }
    }
    
    store.dispatch({
      type: "selectedEstablishment/update",
      payload: establishmentId,
    });
  }
}
